module.exports = __webpack_public_path__ + "static/media/premium.ca2014f4.svg";